<template>
  <div>
    <div class="d-flex justify-center mb-9">
      <v-card class="w-100" flat>
        <div v-if="stepOne">
          <div class="d-flex justify-space-between align-center">
            <div>
              <span class="h1">ADD PAYMENT FOR </span>
              <span class="heading-3"
                >{{ GetPreviewUser?.FirstName }}
                {{ GetPreviewUser?.LastName }}</span
              >
            </div>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <!-- <v-row>
            <v-col cols="12" md="8">
              <div class="pb-3">
                <b>Add Self-Study Course</b>
              </div>
              <v-text-field
                outlined
                single-line
                dense
                hide-details=""
                label="[Enter course name, author or ID]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <div class="mt-10">
                <v-icon color="red">mdi-delete </v-icon>
              </div>
            </v-col>
          </v-row> -->
          <!-- <v-row
            v-for="(div, index) in divs"
            :key="div.id"
            :div="(div = index)"
          >
            <v-col cols="12" md="8">
              <div class="pb-3">
                <b>Add Self-Study Course</b>
              </div>
              <v-text-field
                outlined
                single-line
                dense
                hide-details=""
                label="[Enter course name, author or ID]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <div class="mt-10">
                <v-icon color="red" @click="deleteRow(index)"
                  >mdi-delete
                </v-icon>
              </div>
            </v-col>
          </v-row> -->
          <!-- <div class="pt-3">
            <v-btn color="primary" text @click="addRow"> + Add another </v-btn>
          </div> -->
          <!-- <b class="mb-2">At a time you can add payment of one item</b> -->
          <v-radio-group v-model="selectItem" class="pa-0 ma-0">
            <v-radio value="storeItem">
              <template v-slot:label>
                <div class="mt-1">Store Item</div>
              </template>
            </v-radio>
            <v-radio value="seminarItem" class="">
              <template v-slot:label>
                <div class="mt-1">IBA Seminar</div>
              </template>
            </v-radio>
          </v-radio-group>
          <v-row>
            <!-- <v-col cols="12" md="6">
              <div class="pb-3">
                <b>Add Store Item</b>
              </div>
              <v-select
                outlined
                dense
                label="store items"
                attach
                v-model="storeItemId"
                :items="GetProducts"
                item-text="ProductName"
                item-value="Id"
                @change="getProductDetailsById(storeItemId)"
                single-line
                hide-details=""
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <div class="pb-4">
                <b>Quantity </b> 
              </div>
                  <v-btn depressed small >
                    <v-icon class="" size="16px" color="primary"
                      >mdi-minus
                    </v-icon>
                  </v-btn>
                    <span class="pa-4">0</span>
                  <v-btn
                    depressed
                    small
                    color="primary"
                  >
                    <v-icon class="" size="16px">mdi-plus </v-icon>
                  </v-btn>
              </v-col> -->
            <!-- <v-col cols="12" md="2">
              <div class="mt-10">
                <v-icon color="red">mdi-delete </v-icon>
              </div>
            </v-col> -->
          </v-row>
          <div v-if="selectItem == 'storeItem'">
            <v-row v-for="(divtow, index) in storeItemArray" :key="index">
              <v-col cols="12" md="6">
                <div class="pb-3">
                  <b>Add Store Item</b>
                </div>
                <v-select
                  outlined
                  dense
                  label="store items"
                  attach
                  v-model="storeItemArray[index].id"
                  :items="getProduct(divtow)"
                  @change="
                    getProductDetailsById(storeItemArray[index].id, index)
                  "
                  item-text="ProductName"
                  item-value="Id"
                  single-line
                  :error-messages="
                    $v.storeItemArray.$each[index].id.$error
                      ? 'Store Item is required'
                      : null
                  "
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <div class="pb-4">
                  <b>Quantity ({{ storeItemArray[index].totalStock }})</b>
                </div>
                <v-btn
                  depressed
                  small
                  @click="decreaseItem(index)"
                  :disabled="storeItemArray[index].quantity <= 1"
                >
                  <v-icon class="" size="16px" color="primary"
                    >mdi-minus
                  </v-icon>
                </v-btn>
                <span class="pa-4" v-if="storeItemArray[index].quantity"
                  >{{ storeItemArray[index].quantity }}
                </span>
                <span class="pa-4" v-else>0 </span>
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="increaseItem(index)"
                  :disabled="
                    storeItemArray[index].quantity ==
                    storeItemArray[index].totalStock
                  "
                >
                  <v-icon class="" size="16px">mdi-plus </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="2" v-if="index > 0">
                <div class="mt-10">
                  <v-icon color="red" @click="deleteRowtwo(index)"
                    >mdi-delete
                  </v-icon>
                </div>
              </v-col>
            </v-row>
            <div class="pt-3">
              <v-btn color="primary" text @click="addRowtwo">
                + Add another
              </v-btn>
            </div>
          </div>
          <v-row v-if="selectItem == 'seminarItem'">
            <!-- <v-col cols="12" md="6">
              <div class="pb-3">
                <b>Add IBA in-house Seminar</b>
              </div>
              <v-text-field
                outlined
                single-line
                dense
                hide-details=""
                label="Enter seminar ID"
              >
              </v-text-field>
            </v-col> -->
            <!-- <v-col cols="12" md="2">
              <div class="mt-10">
                <v-icon color="red">mdi-delete </v-icon>
              </div>
            </v-col> -->
            <v-row v-for="(divone, index) in selectDataList" :key="index">
              <v-col cols="12" md="6">
                <div class="pb-3">
                  <b>Add IBA in-house Seminar</b>
                </div>
                <v-select
                  outlined
                  dense
                  label="[Enter seminar ID]"
                  attach
                  v-model="selectDataList[index].selectedItem"
                  @change="
                    getSeminarDetailById(
                      selectDataList[index].selectedItem,
                      index
                    )
                  "
                  :items="getFilteredItems(divone)"
                  item-text="Id"
                  item-value="Id"
                  :error-messages="
                    $v.selectDataList.$each[index].selectedItem.$error
                      ? 'Seminar is required'
                      : null
                  "
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <div class="mt-10" v-if="index > 0">
                  <v-icon color="red" @click="deleteRowone(index)">
                    mdi-delete
                  </v-icon>
                </div>
              </v-col>
            </v-row>
            <div class="">
              <v-btn color="primary" text @click="addRowone">
                + Add another
              </v-btn>
            </div>
            <v-row class="mt-3">
              <v-col cols="12" md="6" class="pt-0">
                <div class="mb-2">
                  <span>Add Discount Code</span>
                </div>
                <div>
                  <v-text-field
                    label=""
                    filled
                    rounded
                    hide-details=""
                    v-model="ValidateSeminarCouponCode"
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div class="mt-6">
                  <v-btn
                    color="primary"
                    text
                    @click="ValidateSeminarCoupon"
                    :disabled="btnloader"
                  >
                    <span v-if="btnloader != true">Validate</span>
                    <v-progress-circular
                      v-else
                      indeterminate
                      size="20"
                      class="px-5"
                      color="black"
                      v-show="btnloader"
                    ></v-progress-circular>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-row>
          <v-row v-if="getMembershipByUserId.Name == 'Instructor'" class="mt-3">
            <v-col cols="12" md="5" class="pr-0 d-flex pb-0">
              Apply User Credits
              <span class="font-16-green">(USD 65.00 Balance)</span>
            </v-col>
            <v-col cols="12" md="2" class="pl-0">
              <div class="d-flex justify-start">
                <v-switch class="mt-0" v-model="ToggleOne">
                  <template v-slot:label>
                    <div v-if="ToggleOne" class="pl-2">On</div>
                    <div v-else class="pl-2">Off</div>
                  </template>
                </v-switch>
              </div>
            </v-col>
          </v-row>
          <div v-if="selectItem == 'storeItem'">
            <v-row class="mt-3">
              <v-col cols="12" md="6" class="pt-0">
                <div class="mb-2">
                  <span>Add Discount Code</span>
                </div>
                <div>
                  <v-text-field
                    label=""
                    filled
                    rounded
                    hide-details=""
                    v-model="ValidateCouponCode"
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div class="mt-6">
                  <v-btn
                    color="primary"
                    text
                    @click="ValidateCoupon"
                    :disabled="btnloader"
                  >
                    <span v-if="btnloader != true">Validate</span>
                    <v-progress-circular
                      v-else
                      indeterminate
                      size="20"
                      class="px-5"
                      color="black"
                      v-show="btnloader"
                    ></v-progress-circular>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <table class="w-100 mt-9">
              <tr>
                <th style="width: 20%">
                  <div class="d-flex justify-center py-2 text-center">Product Type</div>
                </th>
                <th style="width: 36%">
                  <div class="d-flex justify-center py-2 text-center">Name</div>
                </th>
                <th style="width: 15%">
                  <div class="d-flex justify-center py-2 text-center">Unit Price</div>
                </th>
                <th style="width: 14%">
                  <div class="d-flex justify-center py-2 text-center">Quantity</div>
                </th>
                <th style="width: 15%">
                  <div class="d-flex justify-center py-2 text-center">Subtotal</div>
                </th>
              </tr>
              <tr v-for="(item, index) in storeItemArray" :key="index">
                <td>
                  <div
                    class="d-flex justify-center py-2"
                    v-if="item.name"
                  ></div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2 text-center" v-if="item.name">
                    {{ item.name }}
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2 text-center" v-if="item.price">
                    ${{ item.price }}.00
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2 text-center" v-if="item.quantity">
                    {{ item.quantity }}
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2 text-center" v-if="item.price">
                    $ {{ item.price * item.quantity }}.00
                  </div>
                </td>
              </tr>
              <!-- <tr>
                <td>
                  <div class="d-flex justify-center py-2">Self-Study Course</div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2">Eastern Medicine</div>
                </td>
                <td><div class="d-flex justify-center py-2"></div></td>
                <td><div class="d-flex justify-center py-2">1</div></td>
                <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex justify-center py-2">Self-Study Course</div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2">Eastern Medicine</div>
                </td>
                <td><div class="d-flex justify-center py-2"></div></td>
                <td><div class="d-flex justify-center py-2">1</div></td>
                <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex justify-center py-2">Self-Study Course</div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2">Eastern Medicine</div>
                </td>
                <td><div class="d-flex justify-center py-2"></div></td>
                <td><div class="d-flex justify-center py-2">1</div></td>
                <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
              </tr> -->
              <tr>
                <td colspan="4">
                  <div class="d-flex justify-start px-4 py-2">
                    <b>Product Total</b>
                  </div>
                </td>

                <td>
                  <div class="d-flex justify-center py-2 text-center">
                    <b> $ {{ formatPrice(totalPrice) }}</b>
                  </div>
                </td>
              </tr>
            </table>
            <v-row class="mt-3">
              <v-col cols="12" md="5" class="pr-0 d-flex pb-0">
                Does this order require shipping
              </v-col>
              <v-col cols="12" md="2" class="pl-0 pt-2">
                <div class="d-flex justify-start">
                  <!-- <v-btn
                    color="primary"
                    class="px-9"
                    v-if="this.PaymentOption === 'online'"
                    v-show="this.stepTwo == false"
                    @click="GoToStepTwo()"
                    >Next
                  </v-btn> -->
                  <v-switch
                    class="mt-0"
                    v-model="membershipNewsTogglebtn"
                    :disabled="
                      !!(
                        selectItem === 'storeItem' &&
                        this.storeItemArray.length >= 1 &&
                        this.storeItemArray[0].id
                      )
                    "
                  >
                    <!-- @click="showSubcribeModel()" -->
                    <template v-slot:label>
                      <div v-if="membershipNewsTogglebtn">On</div>
                      <div v-else>Off</div>
                    </template>
                  </v-switch>
                </div>
              </v-col>
            </v-row>
            <div v-show="membershipNewsTogglebtn" class="" max-width="600">
              <v-row>
                <v-col cols="12" md="10">
                  <!-- <div class="mb-2">
                    <span style="color: #1976d3"> Use Member Address </span>
                  </div> -->
                    <!-- <v-text-field
                      type="text"
                      id="search_input"
                      placeholder="Enter a location"
                      @place_changed="onPlaceChanged"
                      v-model="searchLocation"
                      :error-messages="
                      $v.searchLocation.$error ? 'Location is required' : null
                      "
                      @input="getSearchLocation"
                      clearable
                    ></v-text-field> -->
                  <div style="position: relative">
                    <gmap-autocomplete
                      id="search_input"
                      @place_changed="onPlaceChanged"
                      :select-first-on-enter="true"
                      class="gmap-autocomplete"
                      ref="autocomplete"
                      v-if="showAutocomplete"
                    >
                    </gmap-autocomplete>
                    <v-btn
                      icon
                      small
                      style="position: absolute; right: 8px; top: 8px"
                      @click="clearSearchLocation"
                      v-if="searchLocation"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <div
                      v-if="
                        !$v.searchLocation.required && $v.searchLocation.$dirty
                      "
                      class="error-message px-3"
                    >
                      Location is required
                    </div>
                  </div>
                  <v-row class="mt-4">
                    <v-col col="12" md="6">
                      <div class="pb-3">
                        <b>First Name</b>
                      </div>
                      <v-text-field
                        dense
                        outlined
                        placeholder=""
                        v-model="form.ShippingDetailDTO.FirstName"
                        :error-messages="
                          getErrorMessageDTO('FirstName', 'FirstName')
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col col="12" md="6">
                      <div class="pb-3">
                        <b class="pb-2">Last Name</b>
                      </div>
                      <v-text-field
                        dense
                        outlined
                        placeholder=""
                        v-model="form.ShippingDetailDTO.LastName"
                        :error-messages="
                          getErrorMessageDTO('LastName', 'LastName')
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div class="mt-3">
                    <div class="">
                      <b>Street Address</b>
                    </div>
                    <v-text-field
                      dense
                      flat
                      outlined
                      single-line

                      append-icon="mdi-check"
                      class="my-5"
                      v-model="form.ShippingDetailDTO.StreetAddress1"
                      :error-messages="
                        getErrorMessageDTO('StreetAddress1', 'StreetAddress1')
                      "
                    ></v-text-field>

                    <!-- <v-text-field
                      dense
                      flat
                      outlined
                      single-line
                      disabled
                      append-icon="mdi-check"
                      class="my-5"
                      v-model="form.ShippingDetailDTO.StreetAddress2"
                    ></v-text-field> -->
                    <v-row>
                      <v-col col="12" md="6">
                        <div class="pb-3">
                          <b>City</b>
                        </div>
                        <v-text-field
                          single-line
                          outlined
                          flat
                          solo
                          disabled
                          dense
                          v-model="form.ShippingDetailDTO.City"
                          :error-messages="getErrorMessageDTO('City', 'City')"
                        ></v-text-field>
                      </v-col>
                      <v-col col="12" md="6">
                        <div class="pb-3">
                          <b class="pb-2">State / Province</b>
                        </div>
                        <v-text-field
                          single-line
                          outlined
                          flat
                          solo
                          disabled
                          dense
                          v-model="form.ShippingDetailDTO.Province"
                          :error-messages="
                            getErrorMessageDTO('Province', 'Province')
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="12" md="6">
                        <div class="pb-3">
                          <b class="pb-2">Zip Code</b>
                        </div>
                        <v-text-field
                          single-line
                          outlined
                          flat
                          solo
                          dense
                          v-model="form.ShippingDetailDTO.ZipCode"
                        ></v-text-field>
                      </v-col>
                      <v-col col="12" md="6">
                        <div class="pb-3">
                          <b class="pb-2">Country</b>
                        </div>
                        <v-text-field
                          single-line
                          outlined
                          flat
                          solo
                          disabled
                          dense
                          v-model="form.ShippingDetailDTO.Country"
                          :error-messages="
                            getErrorMessageDTO('Country', 'Country')
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <div class="mt-3">
                      <b>Phone Number</b>
                    </div>
                    <v-text-field
                      dense
                      outlined
                      maxlength="17"
                      minlength="7"
                      class="my-5"
                      placeholder=""
                      v-model="form.ShippingDetailDTO.PhoneNumber"
                      :error-messages="
                        getErrorMessageDTO('PhoneNumber', 'PhoneNumber')
                      "
                    ></v-text-field>

                    <div class="py-3">
                      <b>Set shipping Method </b>
                    </div>

                    <v-autocomplete
                      v-model="form.ShippingDetailDTO.ShippingMethod"
                      :error-messages="
                        getErrorMessageDTO('ShippingMethod', 'ShippingMethod')
                      "
                      :items="ShippingTypeArray"
                      dense
                      filled
                      single-line
                      background-color="transparent"
                      class="mt-3 pa-0"
                      outlined
                      attach
                      label="Select"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              customMessage
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <div class="mt-4"><b>Special shipping notes</b></div>
                    <v-textarea
                      outlined
                      flat
                      rows="3"
                      dense
                      auto-grow
                      class="mt-5"
                      single-line
                      label=""
                      row-height="30"
                      counter="150"
                      v-model="form.ShippingDetailDTO.ShippingNote"
                    >
                    </v-textarea>
                    <div class="mt-4">
                      <v-expansion-panels flat class="mb-4">
                        <v-expansion-panel class="pa-0 ma-0">
                          <v-expansion-panel-header class="pt-0 pb-0 px-0 ma-0">
                            <v-checkbox
                              class="mt-0"
                              v-model="
                                form.ShippingDetailDTO.ShippingTermAndConditions
                              "
                            >
                              <template v-slot:label>
                                <div class="pa-4">
                                  <span style="color: #1976d3">
                                    Shipping Terms and Conditions
                                  </span>
                                </div>
                              </template>
                            </v-checkbox></v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            I confirm that the shipping address entered above
                            (particularly Country, Region, and Postal Code) is
                            correct. If the shipping address is incorrect and
                            there are additional shipping charges, I hereby
                            grant the IBA permission to charge my credit card
                            for the remainder of the fees. Additionally, if I
                            select a shipping method that it un-tracked and/or
                            uninsured, I assume all liability for missing
                            packages.
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <!-- <v-row>
            <v-col cols="12" md="8">
              <div class="py-3">
                <b>Set shipping Mathod </b>
              </div>
              <v-autocomplete
                v-model="ShippingType"
                :items="people"
                dense
                filled
                item-text="name"
                hide-details
                single-line
                background-color="transparent"
                class="mt-3 pa-0"
                outlined
                item-value="name"
                label="Select"
                attach
              >
              </v-autocomplete>
            </v-col>
          </v-row> -->
            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="6">
                    <div>
                      <b>Product Total </b>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex mx-5">
                      <b>${{ formatPrice(totalPrice) }} USD </b>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="discounted !== 0.0">
                  <v-col cols="6">
                    <div>Product Discount</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex mx-5">
                      ${{ (discounted)?.toFixed(2) }} USD
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="couponDiscount !== 0.0">
                  <v-col cols="6">
                    <div>Coupon Discount</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex mx-5">
                      ${{ (couponDiscount)?.toFixed(2) }} USD
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <div>Total Discount</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex mx-5">
                      ${{ (discounted + couponDiscount)?.toFixed(2) }} USD
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <div>Subtotal</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex mx-5">
                      ${{
                        formatPrice(
                          totalPrice - discounted - couponDiscount,
                          "tax"
                        )
                      }}
                      USD
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <div>Shipping</div>
                  </v-col>
                  <v-col cols="6">
                    <div v-if="shippingPrice" class="d-flex mx-5">
                      ${{ shippingPrice }} USD
                    </div>
                    <div v-else class="d-flex mx-5">$0.00 USD</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <div>Tax</div>
                  </v-col>
                  <v-col cols="6">
                    <div
                      class="d-flex mx-5"
                      v-if="this.storeItemArray.length > 0 && taxAdded"
                    >
                      ${{ formatPrice(taxVal) }} USD
                    </div>
                    <div class="d-flex mx-5" v-else>$0.00 USD</div>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="6">
                    <div>User Credits</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex justify-end">(-$23.22)</div>
                  </v-col>
                </v-row> -->

                <v-divider></v-divider>
                <v-row>
                  <v-col cols="6">
                    <div class="">
                      <b>Total</b>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex mx-5">
                      <b
                        >${{
                          formatPrice(
                            totalPrice -
                              discounted -
                              couponDiscount +
                              shippingPrice +
                              taxVal
                          )
                        }}
                        USD
                      </b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div v-if="selectItem == 'seminarItem'" class="mt-3">
            <table class="w-100 mt-9">
              <tr>
                <th style="width: 30%">
                  <div class="d-flex justify-center py-2 text-center">Name</div>
                </th>
                <th style="width: 15%">
                  <div class="d-flex justify-center py-2 text-center">Full Price</div>
                </th>
                <th style="width: 15%">
                  <div class="d-flex justify-center py-2 text-center">Early Bird Price</div>
                </th>
                <th style="width: 25%">
                  <div class="d-flex justify-center py-2 text-center">
                    Monitor Rate Discount
                  </div>
                </th>
                <th style="width: 15%">
                  <div class="d-flex justify-center py-2 text-center">Subtotal</div>
                </th>
              </tr>
              <tr v-for="(item, index) in selectDataList" :key="index">
                <td>
                  <div class="d-flex justify-center py-2 text-center" v-if="item.name">
                    {{ item.name }}
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-center py-2 text-center" v-if="item.price">
                    {{ item.price }}.00 USD
                  </div>
                </td>
                <td>
                  <div
                    class="d-flex justify-center py-2 text-center"
                    v-if="item.earlyBirdPrice"
                  >
                    {{ item.earlyBirdPrice }}.00 USD
                  </div>
                </td>
                <td>
                  <div
                    class="d-flex justify-center py-2 text-center"
                    v-if="item.monitorDiscountRate"
                  >
                    {{ item.monitorDiscountRate }}.00 USD
                  </div>
                </td>
                <td>
                  <div
                    class="d-flex justify-center py-2 text-center"
                    v-if="item.totalPrice"
                  >
                    {{ item.totalPrice }}.00 USD
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="d-flex justify-start px-4 py-2 ">
                    <b>Seminars Total</b>
                  </div>
                </td>

                <td>
                  <div class="d-flex justify-center py-2 text-center">
                    <b> {{ totalSeminarPrice }}.00 USD</b>
                  </div>
                </td>
              </tr>
            </table>
            <div class="mt-6">
              <div><b>Seminars Total: ${{ totalSeminarPrice }}.00 USD</b></div>
              <div class="my-1">Coupon Discount: ${{ (couponSeminarDiscount)?.toFixed(2) }} USD</div>
              <div><b>Total: ${{ (totalSeminarPrice - couponSeminarDiscount)?.toFixed(2) }} USD</b></div>
            </div>
          </div>
        </div>
        <div v-show="stepOne">
          <v-row class="mt-5">
            <v-col cols="12" md="10"
              ><div class="">
                <b class="font-18">Payment Option:</b>
              </div>
              <v-radio-group v-model="PaymentOption" class="pa-0 ma-0">
                <v-radio value="online">
                  <template v-slot:label>
                    <div class="mt-1">ONLINE (Process Credit Card)</div>
                  </template>
                </v-radio>
                <v-radio value="offline" class="">
                  <template v-slot:label>
                    <div class="mt-1">
                      OFFLINE (Generate record/invoice/email without Payment )
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>


          <!--------------------------------Data--Table --------------------------------->
        </div>
        
        <div v-show="stepTwo">
          <div class="d-flex justify-space-between align-center">
            <div>
              <span class="h1">Online Payment </span>
            </div>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <div class="h2 mb-6 mt-8">
            <b>Payment Information </b>
          </div>
          <div class="font-18">
            <div class="mb-2">User: <b>{{ GetPreviewUser?.FirstName }} {{ GetPreviewUser?.LastName }}</b></div>
            <div v-if="selectItem == 'storeItem'">Total: <b>USD {{ formatPrice(totalPrice - discounted - couponDiscount + shippingPrice + taxVal) }}</b></div>
            <div v-if="selectItem == 'seminarItem'">Total: <b>USD {{ (totalSeminarPrice - couponSeminarDiscount)?.toFixed(2) }}</b></div>
            
            <v-card outlined class="mt-7 pb-2 pt-4 px-4">
              <p><b>Name on Card</b></p>
              <v-text-field
                dense
                label="Card Holder Name"
                single-line
                outlined
                v-model="form.Payment.CardHolderName"
                :error-messages="
                  getErrorMessageCardHolderName(
                    form.Payment.CardHolderName
                  )
                "
              ></v-text-field>
  
              <p><b>Card Number</b></p>
              <v-text-field
                label="Card Number"
                v-model="form.Payment.CardNumber"
                dense
                outlined
                single-line
                maxlength="16"
                :error-messages="
                        getErrorMessageCardNumber(form.Payment.CardNumber)
                      "
              ></v-text-field>
  
              <div class="d-flex justify-between gap-3">
                <div style="flex-basis: 50%; width: 50%">
                  <p><b>Expiration Date</b></p>
                  <v-text-field
                    v-model="form.Payment.CardExp"
                    class=""
                    label="MM/YY"
                    maxlength="5"
                    dense
                    outlined
                    single-line
                    @input="formatExpiryDate"
                      :error-messages="
                        getErrorMessageExpiryDate(form.Payment.CardExp)
                      "
                  ></v-text-field>
                </div>
  
                <div style="flex-basis: 50%; width: 50%">
                  <p><b>CVV</b></p>
                  <v-text-field
                    class=""
                    v-model="form.Payment.CardCVV"
                    label="CVV"
                    dense
                    outlined
                    :maxlength="form.Payment.CardNumber?.length === 15 ? 4 : 3" 
                    single-line
                    :error-messages="
                      getErrorCardNumberCvv(form.Payment.CardCVV)
                    "
                  ></v-text-field>
                </div>
                <!-- <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  attach
                  :nudge-top="300"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Picker in menu"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      hide-details
                      dense
                      outlined
                      single-line
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu> -->
              </div>
            </v-card>
          </div>
          
          <!-- <v-row no-gutters>
            <v-col cols="6">User Credits</v-col>
            <v-col cols="6">(-$23.33)</v-col>
          </v-row> -->

          <!-- <div v-if="selectItem == 'storeItem'">
            <div class="font-18 mb-3 mt-8 primary--text">
              <b>ORDER SUMMARY</b>
            </div>
            <div>
              <v-row no-gutters>
                <v-col cols="6"><b>Product Total</b></v-col>
                <v-col cols="6"
                  ><b>${{ formatPrice(totalPrice) }} USD</b></v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">Product Discount</v-col>
                <v-col cols="6">${{ discounted.toFixed(2) }} USD</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">Coupon Discount</v-col>
                <v-col cols="6">${{ couponDiscount.toFixed(2) }} USD</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">Total Discount</v-col>
                <v-col cols="6"
                  >${{ (discounted + couponDiscount).toFixed(2) }} USD</v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">Subtotal</v-col>
                <v-col cols="6"
                  >${{
                    formatPrice(totalPrice - discounted - couponDiscount, "tax")
                  }}
                  USD</v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">Shipping</v-col>
                <v-col cols="6">
                  <div v-if="shippingPrice" class="d-flex">
                    ${{ shippingPrice }} USD
                  </div>
                  <div v-else class="d-flex">$0.00 USD</div>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6">Tax</v-col>
                <v-col cols="6"
                  ><div
                    class="d-flex"
                    v-if="this.storeItemArray.length > 0 && taxAdded"
                  >
                    ${{ formatPrice(taxVal) }} USD
                  </div>
                  <div class="d-flex" v-else>$0.00 USD</div></v-col
                >
              </v-row>
              <v-divider></v-divider>
              <v-row no-gutters>
                <v-col cols="6"><b>Total</b></v-col>
                <v-col cols="6"
                  ><b
                    >${{
                      formatPrice(
                        totalPrice -
                          discounted -
                          couponDiscount +
                          shippingPrice +
                          taxVal
                      )
                    }}
                    USD</b
                  ></v-col
                >
              </v-row>
            </div>
          </div> -->

          <!-- <div class="font-18 my-8 d-flex justify-space-between">
            <b>Billing Address</b>
            <span class="primary--text cursor-pointer">Use Member Address</span>
          </div>
          <div>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">First Name:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      :error-messages="
                        getErrorMessage('FirstName', 'FirstName')
                      "
                      dense
                      v-model="form.BillingDetails.FirstName"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Last Name:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.LastName"
                      :error-messages="getErrorMessage('LastName', 'LastName')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="my-7">
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">City:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.City"
                      :error-messages="getErrorMessage('City', 'City')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">State:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.Province"
                      :error-messages="getErrorMessage('City', 'City')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="my-7">
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Street Address1:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.StreetAddress1"
                      :error-messages="
                        getErrorMessage('StreetAddress1', 'StreetAddress1')
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Street Address2:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.StreetAddress2"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">ZipCode:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.ZipCode"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Country:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.BillingDetails.Country"
                      :error-messages="getErrorMessage('Country', 'Country')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="my-7">
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3">
                    <div class="mr-3 d-flex align-center">Phone Number:</div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      outlined
                      maxlength="17"
                      minlength="7"
                      dense
                      v-model="form.BillingDetails.PhoneNumber"
                      :error-messages="
                        getErrorMessage('PhoneNumber', 'PhoneNumber')
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-1">
                <v-row>
                  <v-col cols="3"> </v-col>
                  <v-col cols="9"> </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div> -->
          
        </div>
        <div class="d-flex justify-space-between mt-11">
          <div>
            <v-btn
              color="primary"
              class="px-9"
              v-show="this.stepTwo == true"
              @click="GoBack()"
              >Back</v-btn
            >
          </div>
          <div>
            <v-btn
              color="primary"
              :disabled="submitBtnloader"
              class="px-9"
              v-if="this.PaymentOption === 'offline' || this.stepTwo == true"
              @click="Submit()"
              ><span v-if="submitBtnloader != true">Submit</span
              ><v-progress-circular
                indeterminate
                size="20"
                v-else
                class="px-5"
                color="white"
                v-show="submitBtnloader"
              ></v-progress-circular
            ></v-btn>
            <v-btn
              color="primary"
              class="px-9"
              v-if="this.PaymentOption === 'online'"
              v-show="this.stepTwo == false"
              @click="GoToStepTwo()"
              >Next
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
    <v-dialog v-model="OfflineSuccessfullDialog" max-width="400" persistent>
      <v-card class="pa-5 pb-8">
        <div class="d-flex justify-end">
          <v-icon @click="OfflineSuccessfullDialog = false">mdi-close</v-icon>
        </div>
        <div v-if="this.PaymentOption === 'offline'">
          <div
            class="d-flex justify-center"
            style="font-size: 2rem; color: rgb(63, 72, 204); font-weight: bold"
          >
            Success
          </div>
          <div class="d-flex justify-center mt-5" style="font-size: 1.3rem">
            Your offline payment has been <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            processed. A record of this <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction and an invoice will <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            be recorded in this User's <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            account. An email of the <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction details will be sent <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            to the User.
          </div>
        </div>
        <div v-else>
          <div
            class="d-flex justify-center"
            style="font-size: 2rem; color: rgb(63, 72, 204); font-weight: bold"
          >
            Success
          </div>
          <div class="d-flex justify-center mt-5" style="font-size: 1.3rem">
            Your payment has been <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            processed. A record of this <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction and an invoice will <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            be recorded in this User's <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            account. An email of the <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction details will be sent <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            to the User.
          </div>
        </div>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import axios from "axios";
const alphaWithSpaces = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s]+$/.test(value);
};
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
const allowDigitsAndSteric = (value) => {
  if (!value) return true;
  return /^[0-9*]+$/.test(value); // to allow digits and *
};
export default {
  props: ["BillingandPurchasePaymentProcess"],
  name: "BillingPurchasePaymentComponent",
  mixins: [validationMixin],
  data() {
    return {
      isFormSubmitted: false,
      ToggleOne: false,
      taxAdded: false,
      tax: 0,
      customMessage: "No data available",
      showAutocomplete: true,
      searchLocation: "",
      ShippingTypeArray: [],
      friends: ["Sandra Adams", "Britta Holt"],
      OfflineSuccessfullDialog: false,
      ValidateCouponCode: "",
      ValidateSeminarCouponCode: "",
      btnloader: false,
      submitBtnloader: false,
      people: [
        { header: "UPS" },
        { name: "Second Day Air ($30.40)", group: "UPS" },
        { name: "Standard ($183.75)", group: "UPS" },
        { name: "Next Day Air (Morning) ($199.19)", group: "UPS" },
        { name: "Next Day Air (Afternoon) ($112.22)", group: "UPS" },
        { divider: true },
        { header: "USPS" },
        { name: "Priority Mail Express 1-Day(R) ($112.15)", group: "USPS" },
        {
          name: "Priority Mail (R) Large Flat Rate Box ($27.80) ",
          group: "USPS",
        },
        {
          name: "Priority Mail(R) Medium Flat Rate Box ($22.80)",
          group: "USPS",
        },
        {
          name: "Priority Mail(R) Small Flat Rate Box ($15.80)",
          group: "USPS",
        },
      ],
      list: [
        { name: "seminar1", price: 10 },
        { name: "seminar2", price: 20 },
        { name: "seminar3", price: 30 },
        { name: "seminar4", price: 40 },
      ],
      selectDataList: [
        {
          selectedItem: null,
          name: "",
          price: null,
          earlyBirdPrice: null,
          monitorDiscountRate: null,
          totalPrice: null,
        },
      ],
      earlyBirdPriceDiscount: false,
      divtow: 0,
      divstwo: [1],
      divone: 0,
      divsone: [1],
      div: 0,
      divs: [],
      divstore: 0,
      divsstore: [],
      membershipNewsToggleTwo: false,
      membershipNewsToggleOne: false,
      membershipNewsTogglebtn: false,
      Toggletwo: false,
      selectItem: "storeItem",

      name: "[USER_FIRST_LAST_NAME]",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      PaymentFor: [],
      PaymentOption: "offline",
      PaymentInformationFee: [],
      stepOne: true,
      stepTwo: false,
      CourseList: ["CBP", "CBP-A", "ADV"],
      search: "",
      storeItemArray: [
        {
          id: null,
          name: "",
          totalStock: null,
          physical: null,
          quantity: null,
          price: null,
          discountPercentage: null,
        },
      ],
      coupon: null,
      seminarCoupon: null,
      form: {
        PaidAmount: 0,
        SeminarIds: [],
        StoreGuestUser: {
          Email: "",
        },
        StoreIds: [],
        // BillingDetails: {
        //   FirstName: "",
        //   LastName: "",
        //   StreetAddress1: "",
        //   // StreetAddress2: "",
        //   City: "",
        //   Province: "",
        //   ZipCode: "",
        //   Country: "",
        //   PhoneNumber: "",
        //   UserId: 0,
        // },
        Payment: {
          PaymentCardId: 0,
          PaymentType: 1,
          CardHolderName: "",
          CardNumber: "",
          CardExp: "",
          CardCVV: "",
        },
        ShippingDetailDTO: {
          FirstName: "",
          LastName: "",
          StreetAddress1: "",
          // StreetAddress2: "",
          City: "",
          Province: "",
          ZipCode: "",
          Country: "",
          PhoneNumber: "",
          ShippingNote: "",
          ShippingMethod: "",
          ShippingTermAndConditions: false,
        },
        UserId: 0,
        Coupon: 0,
        Price: 0,
      },
      couponDiscountType: null,
    };
  },
  validations: {
    searchLocation: {
      required,
    },
    form: {
      Payment: {
        CardHolderName: {
          required,
          alpha: alphaWithSpacesAndSpecialChars,
        },
        CardNumber: {
          required,
          numeric,
          minLength: minLength(15),
        },
        CardExp: {
          required,
          expiryDate(value) {
            if (!value) {
              return "Expiry date is required.";
            }

            const [month, year] = value.split("/");
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear() % 100;
            const currentMonth = currentDate.getMonth() + 1;

            if (
              parseInt(month) >= 1 &&
              parseInt(month) <= 12 &&
              parseInt(year) >= currentYear &&
              ((parseInt(year) === currentYear &&
                parseInt(month) >= currentMonth) ||
                parseInt(year) > currentYear)
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        CardCVV: {
          minLength: minLength(3),
            required,
            allowDigitsAndSteric: allowDigitsAndSteric,
        },
      },
      // BillingDetails: {
      //   FirstName: {
      //     required,
      //     alpha: alphaWithSpaces,
      //   },
      //   LastName: {
      //     required,
      //     alpha: alphaWithSpaces,
      //   },
      //   StreetAddress1: {
      //     required,
      //   },
      //   // StreetAddress2: {
      //   //   required,
      //   // },
      //   City: {
      //     required,
      //     alpha: alphaWithSpaces,
      //   },
      //   Province: {
      //     required,
      //     alpha: alphaWithSpaces,
      //   },
      //   ZipCode: {
      //     required,
      //   },
      //   Country: {
      //     required,
      //     alpha: alphaWithSpaces,
      //   },
      //   PhoneNumber: {
      //     numeric,
      //     required,
      //     minLength: minLength(7),
      //     maxLength: maxLength(17),
      //   },
      // },
      ShippingDetailDTO: {
        FirstName: {
          required,
          alpha: alphaWithSpaces,
        },
        LastName: {
          required,
          alpha: alphaWithSpaces,
        },
        StreetAddress1: {
          required,
        },
        City: {
          required,
          alpha: alphaWithSpaces,
        },
        Province: {
          // required,
          alpha: alphaWithSpaces,
        },
        ZipCode: {
          // required,
        },
        Country: {
          required,
          alpha: alphaWithSpaces,
        },
        PhoneNumber: {
          numeric,
          required,
          minLength: minLength(7),
          maxLength: maxLength(17),
        },
        ShippingMethod: {
          required,
        },
      },
    },
    storeItemArray: {
      $each: {
        id: {
          required,
        },
      },
    },
    selectDataList: {
      $each: {
        selectedItem: {
          required,
        },
      },
    },
  },
  updated() {
    if (this.selectItem == "seminarItem") {
      this.membershipNewsTogglebtn = false;
    } else if (
      this.selectItem == "storeItem" &&
      this.storeItemArray.length >= 1 &&
      this.storeItemArray[0].id
    ) {
      this.membershipNewsTogglebtn = true;
    }
  },
  mounted() {
    this.form.StoreGuestUser.Email = this.GetPreviewUser.Email;
    this.form.UserId = this.GetPreviewUser;
    if (this.GetProducts.length == 0) {
      const obj = {
        page: 1,
        pageSize: "All",
        search: this.search,
        filters: "",
      };
      this.$store.dispatch("GetProducts", obj);
    }
    // this.fetchData();
  },
  computed: {
    ...mapGetters([
      "GetProducts",
      "GetStoreById",
      "GetPreviewUser",
      "getBillingDetailsInfoByUserId",
      "GetAllSeminarByGroup",
      "GetSeminarBySeminarIdAndUserId",
      "getMembershipByUserId",
      "GetUserPurchaseAndBillings",
    ]),
    totalPrice() {
      if (this.storeItemArray && this.storeItemArray.length > 0) {
        return this.storeItemArray.reduce((total, item) => {
          return total + item.price * item.quantity;
        }, 0);
      } else {
        return 0;
      }
    },
    couponDiscount() {
      if (this.coupon === null) {
        return 0;
      }
      if (this.coupon.DiscountType === 1) {
        return this.totalPrice * (parseFloat(this.coupon.DiscountValue) / 100);
      }
      return this.coupon.DiscountValue;
    },
    couponSeminarDiscount() {
      if (this.seminarCoupon === null) {
        return 0;
      }
      if (this.seminarCoupon.DiscountType === 1) {
        return this.totalSeminarPrice * (parseFloat(this.seminarCoupon.DiscountValue) / 100);
      }
      return this.seminarCoupon.DiscountValue;
    },
    discounted() {
      var discountPrice = 0;
      this.storeItemArray.forEach((x) => {
        if (x.discountPercentage) {
          discountPrice +=
            (parseFloat(x.price) *
              x.quantity *
              parseFloat(x.discountPercentage)) /
            100;
        }
      });
      return discountPrice;
    },
    shippingPrice() {
      let str = this.form.ShippingDetailDTO.ShippingMethod;
      let match = str.match(/\(([^)]+)\)/);
      if (match) {
        let number = parseFloat(match[1]);
        return number;
      }
      return 0;
    },
    taxVal() {
      return this.tax;
    },
    totalSeminarPrice() {
      if (this.selectDataList && this.selectDataList?.length > 0) {
        return this.selectDataList.reduce((total, item) => {
          return total + item.totalPrice;
        }, 0);
      } else {
        return 0;
      }
    },
  },
  methods: {
    onPlaceChanged(place) {
      if (!place || !place.address_components) {
        console.error("No address components available.");
        return;
      }

      this.form.ShippingDetailDTO.StreetAddress1 = "";
      this.form.ShippingDetailDTO.City = "";
      this.form.ShippingDetailDTO.Province = "";
      this.form.ShippingDetailDTO.Country = "";
      this.form.ShippingDetailDTO.ZipCode = "";

      if(place.formatted_address){
        this.form.ShippingDetailDTO.StreetAddress1 = place.formatted_address;
        // this.form.ShippingDetailDTO.StreetAddress2 = place.formatted_address;
        this.searchLocation = place.formatted_address;
      }
      for (const component of place.address_components) {
        const types = component.types;
        if (types.includes("locality")) {
          this.form.ShippingDetailDTO.City = component.long_name;
        }
        if (types.includes("postal_town")) {
          this.form.ShippingDetailDTO.City = component.long_name;
        }
        if (types.includes("administrative_area_level_2") && !this.form.ShippingDetailDTO.City) {
          this.form.ShippingDetailDTO.City = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          this.form.ShippingDetailDTO.Province = component.short_name;
        }
        if (types.includes("country")) {
          this.form.ShippingDetailDTO.Country = component.long_name;
          this.country = component.short_name;
        }
        if (types.includes("postal_code")) {
          this.form.ShippingDetailDTO.ZipCode = component.long_name;
        }

      }
      if (
        this.form.ShippingDetailDTO.Country.toLowerCase() == "united states" && this.form.ShippingDetailDTO.Province.toLowerCase() == "florida"
      ) {
        this.storeItemArray.forEach((item) => {
          if (item.physical) {
            this.taxAdded = true;
            return;
          }
        });
      } else {
        this.taxAdded = false;
        this.tax = 0
      }
      this.shippingMethods();
    },
    shippingMethods() {
      const myHeaders = {
        Host: "ssapi.shipstation.com",
        Authorization:
          "Basic MTdmNjgyYzYyZjU3NGEyMDg5NzI0YTBhNTBmM2UwY2U6YWZhMTIyY2IzZTI0NDU4Njg5MGRlZDY1MDdjMDllMjg=",
        "Content-Type": "application/json",
      };

      const raw = JSON.stringify({
        carrierCode: "ups_walleted",
        toPostalCode: this.country == 'US' && !this.form.ShippingDetailDTO.ZipCode ? '90210' : this.form.ShippingDetailDTO.ZipCode,
        fromPostalCode: "34275",
        toState: this.form.ShippingDetailDTO.Province,
        fromState: null,
        toCountry: this.country,
        toCity: this.form.ShippingDetailDTO.City,
        fromCity: null,
        weight: {
          value: 3,
          units: "ounces",
        },
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        data: raw,
        url: "https://ssapi.shipstation.com/shipments/getrates",
      };

      axios(requestOptions)
        .then((response) => {
          this.ShippingTypeArray = [];
          response.data.forEach((item) => {
            this.ShippingTypeArray.push(
              `${item.serviceName} (${item.shipmentCost})`
            );
          });
        })
        .catch(() => {
          this.customMessage = "No method available for this address";
        });
    },
    clearSearchLocation() {
      this.searchLocation = "";
      this.form.ShippingDetailDTO.StreetAddress1 = "";
      // this.form.ShippingDetailDTO.StreetAddress2 = "";
      this.form.ShippingDetailDTO.City = "";
      this.form.ShippingDetailDTO.Province = "";
      this.form.ShippingDetailDTO.ZipCode = "";
      this.form.ShippingDetailDTO.Country = "";

      this.showAutocomplete = false;
      this.$nextTick(() => {
        this.showAutocomplete = true;
      });
    },
    getSearchLocation() {
      if (!this.searchLocation) {
        this.form.ShippingDetailDTO.StreetAddress1 = "";
        // this.form.ShippingDetailDTO.StreetAddress2 = "";
        this.form.ShippingDetailDTO.City = "";
        this.form.ShippingDetailDTO.Country = "";
        this.form.ShippingDetailDTO.Province = "";
        this.form.ShippingDetailDTO.ZipCode = "";
      }
    },
    // getErrorMessage(fieldName) {
    //   const errorMessages = {
    //     FirstName: {
    //       required: "First name is required",
    //       alpha: "First name only contains alphabetic characters.",
    //     },
    //     LastName: {
    //       required: "Last name is required",
    //       alpha: "Last name only contains alphabetic characters.",
    //     },
    //     StreetAddress1: {
    //       required: "Street address is required",
    //     },
    //     City: {
    //       required: "City is required",
    //       alpha: "City only contains alphabetic characters.",
    //     },
    //     Country: {
    //       required: "Country is required",
    //       alpha: "Country only contains alphabetic characters.",
    //     },
    //     Province: {
    //       required: "Province is required",
    //       alpha: "Province only contains alphabetic characters.",
    //     },
    //     PhoneNumber: {
    //       required: "Phone number is required",
    //       numeric: "Phone number should be only numeric characters",
    //       minLength: "Phone number should be minimum of 7 digits",
    //     },
    //   };
    //   const errorField = this.$v.form.BillingDetails[fieldName];
    //   if (!errorField.$dirty) return null;
    //   const errors = [];
    //   Object.keys(errorField.$params).forEach((param) => {
    //     if (!errorField[param]) {
    //       errors.push(errorMessages[fieldName][param]);
    //     }
    //   });
    //   return errors.length ? errors[0] : null;
    // },
    getErrorMessageDTO(fieldName) {
      const errorMessages = {
        FirstName: {
          required: "First name is required",
          alpha: "First name only contains alphabetic characters.",
        },
        LastName: {
          required: "Last name is required",
          alpha: "Last name only contains alphabetic characters.",
        },
        StreetAddress1: {
          required: "Street address is required",
        },
        City: {
          required: "City is required",
          alpha: "City only contains alphabetic characters.",
        },
        Country: {
          required: "Country is required",
          alpha: "Country only contains alphabetic characters.",
        },
        Province: {
          required: "Province is required",
          alpha: "Province only contains alphabetic characters.",
        },
        PhoneNumber: {
          required: "Phone number is required",
          numeric: "Phone number should be only numeric characters",
          minLength: "Phone number should be minimum of 7 digits",
        },
        ShippingMethod: {
          required: "Shipping method is required",
        },
      };
      const errorField = this.$v.form.ShippingDetailDTO[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    getErrorMessageCardHolderName(field) {
      if (this.$v.form.Payment.CardHolderName.$error == false) {
        return null;
      }
      if (!field) {
        return "Cardholder name is required";
      }
      if (!this.$v.form.Payment.CardHolderName.alpha) {
        return "Only alphabetical characters are allowed.";
      }
      return null;
    },
    getErrorMessageCardNumber(field) {
      if (this.$v.form.Payment.CardNumber.$error == false) {
        return null;
      }
      if (field == null || field == "") {
        return "Card number is required";
      }
      if (!this.$v.form.Payment.CardNumber.numeric) {
        return "Only numeric digits are allowed";
      }
      if (!this.$v.form.Payment.CardNumber.minLength) {
        return "Minimum of 15 digits is required";
      }

      return "Invalid card number.";
    },
    getErrorMessageExpiryDate(field) {
      if (this.$v.form.Payment.CardExp.$error == false) {
        return null;
      }
      if (!field) {
        return "Expiration date is required";
      }
      return "Invalid expiration date.";
    },
    // getErrorCardNumberCvv(field) {
    //   if (this.$v.form.Payment.CardCVV.$error == false) {
    //       return null;
    //     }
    //     if (field == null || field == "") {
    //       return "CVV is required";
    //     }
    //     if (!this.$v.form.Payment.CardCVV.allowDigitsAndSteric) {
    //       return "Only numeric digits are allowed.";
    //     }
    //     if (!this.$v.form.Payment.CardCVV.minLength) {
    //       return "Minimum of 3 digits are required";
    //     }
    //   return "Invalid card cvv.";
    // },
    getErrorCardNumberCvv(field) {
        if (!this.isFormSubmitted) {
          return null; // Do not show errors if the form hasn't been submitted
        }
        const cardLength = this.form.Payment.CardNumber?.length;
        const validCvvLength = cardLength === 15 ? 4 : 3;

        if (!field) {
          return `CVV is required`;
        }
        if (field.length !== validCvvLength) {
          return `CVV must be ${validCvvLength} digits long`;
        }
        if (!this.$v.form.Payment.CardCVV.allowDigitsAndSteric) {
          return "Only numeric digits are allowed";
        }

        return null;
      },
    formatExpiryDate() {
      if (
        this.form.Payment.CardExp.length === 2 &&
        !this.form.Payment.CardExp.includes("/")
      ) {
        this.form.Payment.CardExp += "/";
      }
    },
    formatPrice(publicPrice, tax) {
      if (tax && this.taxAdded) {
        let taxValue = publicPrice * 0.07;
        this.tax = taxValue;
      }
      // Check if the public price has a decimal point
      if (publicPrice.toString().includes(".")) {
        // If it has one digit after the decimal point, add a trailing zero
        if (publicPrice.toString().split(".")[1].length === 1) {
          return publicPrice?.toFixed(2);
        }
      }
      return publicPrice?.toFixed(2);
    },
    // fetchData() {
    //   const obj = {
    //     id: this.GetPreviewUser.Id,
    //   };
    //   this.$store.dispatch("GetBillingDetailsInfoByUserId", obj).then(() => {
    //     this.form.BillingDetails.FirstName =
    //       this.getBillingDetailsInfoByUserId.FirstName;
    //     this.form.BillingDetails.LastName =
    //       this.getBillingDetailsInfoByUserId.LastName;
    //     this.form.BillingDetails.StreetAddress1 =
    //       this.getBillingDetailsInfoByUserId.StreetAddress1;
    //     this.form.BillingDetails.StreetAddress2 =
    //       this.getBillingDetailsInfoByUserId.StreetAddress2;
    //     this.form.BillingDetails.City = this.getBillingDetailsInfoByUserId.City;
    //     this.form.BillingDetails.Province =
    //       this.getBillingDetailsInfoByUserId.Province;
    //     this.form.BillingDetails.ZipCode =
    //       this.getBillingDetailsInfoByUserId.ZipCode;
    //     this.form.BillingDetails.Country =
    //       this.getBillingDetailsInfoByUserId.Country;
    //     this.form.BillingDetails.PhoneNumber =
    //       this.getBillingDetailsInfoByUserId.PhoneNumber;
    //   });
    // },
    ValidateCoupon() {
      if (this.ValidateCouponCode == "") {
        return;
      }
      var obj = {
        Code: this.ValidateCouponCode,
        Type: " Store items",
      };
      this.btnloader = true;
      this.$store.dispatch("ValidateCoupon", obj).then((res) => {
        if (res.Data) {
          this.form.Coupon = res.Data.Code;
        }
        if (res.Status) {
          this.btnloader = false;
          this.coupon = res.Data;
          this.$swal.fire({
            position: "top-end",
            icon: res.Message == "Valid Coupon" ? "success" : "error",
            title: res.Message,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        }
      });
    },
    ValidateSeminarCoupon() {
      if (this.ValidateSeminarCouponCode == "") {
        return;
      }
      var obj = {
        Code: this.ValidateSeminarCouponCode,
        Type: "Seminar items",
      };
      this.btnloader = true;
      this.$store.dispatch("ValidateCoupon", obj).then((res) => {
        if (res.Data) {
          this.form.Coupon = res.Data.Code;
        }
        if (res.Status) {
          this.btnloader = false;
          this.seminarCoupon = res.Data; // Store seminar coupon details
          this.$swal.fire({
            position: "top-end",
            icon: res.Message == "Valid Coupon" ? "success" : "error",
            title: res.Message,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        }
      });
    },
    getProduct(id) {
      const selectedItem = this.storeItemArray
        .filter((data) => data.id && data != id)
        .map((data) => data.id);
      return this.GetProducts.filter((item) => !selectedItem.includes(item.Id));
    },
    getProductDetailsById(id, index) {
      this.$store
        .dispatch("GetStoreById", { Id: id, isWebApp: true })
        .then(() => {
          this.storeItemArray[index].name = this.GetStoreById.Data.ProductName;
          if (this.GetStoreById.Data.Stock == 0) {
            this.storeItemArray[index].id = null;
            this.$swal.fire({
              position: "top-end",
              icon: "info",
              title: `${this.storeItemArray[index].name} product stock is 0`,
              showConfirmButton: false,
              timer: 3000,
              toast: true,
            });
            this.storeItemArray[index].name = "";
            return;
          }
          this.storeItemArray[index].totalStock =
            this.GetStoreById.Data.Stock < 0 ? 0 : this.GetStoreById.Data.Stock;
          this.storeItemArray[index].price = this.GetStoreById.Data.PublicPrice;
          this.storeItemArray[index].physical =
            this.GetStoreById.Data.IsPhysical;
          this.storeItemArray[index].quantity =
            this.GetStoreById.Data.Stock > 0 ? 1 : 0;
          this.storeItemArray[index].discountPercentage =
            this.GetStoreById.Data.DiscountPercentage;
        });
      this.membershipNewsTogglebtn = true;
    },
    getSeminarDetailById(id, index) {
      const obj = {
        seminarId: id,
        id: this.GetPreviewUser.Id,
      };
      this.$store.dispatch("GetSeminarBySeminarIdAndUserId", obj).then(() => {
        this.selectDataList[index].name =
          this.GetSeminarBySeminarIdAndUserId.Course.Title;
        this.selectDataList[index].price =
          this.GetSeminarBySeminarIdAndUserId.SeminarPayment.FullPrice;
        this.selectDataList[index].earlyBirdPrice = null;
        this.selectDataList[index].monitorDiscountRate = null;
        if (
          this.isDateEqualOrGreater(
            this.GetSeminarBySeminarIdAndUserId.SeminarPayment.EarlyBirdEndTime
          )
        ) {
          this.selectDataList[index].earlyBirdPrice =
            this.GetSeminarBySeminarIdAndUserId.SeminarPayment.EarlyBirdPrice;
        }
        if (
          this.GetSeminarBySeminarIdAndUserId.SeminarPayment.MonitorRate &&
          this.GetSeminarBySeminarIdAndUserId.SeminarPayment
            .MonitorDiscountRate > 0
        ) {
          const discount = (this.GetSeminarBySeminarIdAndUserId?.SeminarPayment?.FullPrice * this.GetSeminarBySeminarIdAndUserId?.SeminarPayment?.MonitorDiscountRate) / 100;
          this.selectDataList[index].monitorDiscountRate = this.GetSeminarBySeminarIdAndUserId?.SeminarPayment?.FullPrice - discount;
          // this.selectDataList[index].monitorDiscountRate =
          //   this.GetSeminarBySeminarIdAndUserId.SeminarPayment.MonitorDiscountRate;
        }
        if (this.earlyBirdPriceDiscount) {
          this.selectDataList[index].totalPrice =
            this.GetSeminarBySeminarIdAndUserId.SeminarPayment.EarlyBirdPrice;
        } else if (
          this.GetSeminarBySeminarIdAndUserId.SeminarPayment
            .MonitorDiscountRate == 0
        ) {
          this.selectDataList[index].totalPrice =
            this.GetSeminarBySeminarIdAndUserId.SeminarPayment.FullPrice;
        } else if(this.GetSeminarBySeminarIdAndUserId.SeminarPayment
        .MonitorDiscountRate != 0){
          const discount =
            this.GetSeminarBySeminarIdAndUserId.SeminarPayment
              .MonitorDiscountRate / 100;
          const afterDiscountedPrice =
            this.GetSeminarBySeminarIdAndUserId.SeminarPayment.FullPrice *
            (1 - discount);
          this.selectDataList[index].totalPrice = afterDiscountedPrice;
        }
        this.earlyBirdPriceDiscount = false;
      });
    },
    isDateEqualOrGreater(inputDateStr) {
      const inputDate = new Date(inputDateStr);
      const currentDate = new Date();

      if (inputDate.getFullYear() > currentDate.getFullYear()) {
        this.earlyBirdPriceDiscount = true;
        return true;
      } else if (inputDate.getFullYear() === currentDate.getFullYear()) {
        if (inputDate.getMonth() > currentDate.getMonth()) {
          this.earlyBirdPriceDiscount = true;
          return true;
        } else if (inputDate.getMonth() + 1 === currentDate.getMonth() + 1) {
          if (inputDate.getDate() >= currentDate.getDate()) {
            this.earlyBirdPriceDiscount = true;
            return true;
          }
        }
      }

      return false;
    },
    decreaseItem(index) {
      this.storeItemArray[index].quantity -= 1;
    },
    increaseItem(index) {
      this.storeItemArray[index].quantity += 1;
    },
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
    },
    addRowtwo() {
      this.storeItemArray.push({
        id: null,
        name: "",
        quantity: null,
        totalStock: null,
        price: null,
        discountPercentage: null,
      });
    },
    deleteRowtwo(index) {
      this.storeItemArray.splice(index, 1);
    },
    addRowone() {
      this.selectDataList.push({
        selectedItem: null,
        name: "",
        price: null,
        earlyBirdPrice: null,
        monitorDiscountRate: null,
        totalPrice: null,
      });
    },
    getFilteredItems(selectData) {
      const selectedSeminarIds = this.selectDataList
        .filter((data) => data.selectedItem && data != selectData)
        .map((data) => data.selectedItem);
      return this.GetAllSeminarByGroup.filter(
        (item) => item.SeminarPayment.IbaPayment &&  !selectedSeminarIds.includes(item.Id)
      );
    },
    deleteRowone(index) {
      this.selectDataList.splice(index, 1);
    },
    close() {
      this.$emit("close");
    },
    async addItemsToCart() {
      const cartPromises = this.storeItemArray.map(item => {
        const cartObj = {
          UserId: this.GetPreviewUser.Id,
          IsUser: true,
          ProductId: item.id,
          GuestId: "",
          Quantity: item.quantity,
        };
        return this.$store.dispatch("AddToCart", cartObj);
      });
      await Promise.all(cartPromises);
    },
    async Submit() {
      this.isFormSubmitted = true;
      this.form.UserId = this.GetPreviewUser.Id;
      // this.form.BillingDetails.UserId = this.GetPreviewUser.Id;
      if (this.selectItem == "storeItem") {
        this.$v.storeItemArray.$each.$touch();
        this.$v.form.ShippingDetailDTO.$touch();
        this.$v.searchLocation.$touch();
        if (this.$v.storeItemArray.$each.$invalid) {
          return;
        }
        this.form.PaidAmount = 0;
        this.form.SeminarIds = [];
        this.storeItemArray.forEach((item) => {
          this.form.StoreIds.push(item.id);
        });
      }
      if (this.membershipNewsTogglebtn) {
        this.$v.form.ShippingDetailDTO.$touch();
        this.$v.searchLocation.$touch();
        if (
          this.$v.form.ShippingDetailDTO.$invalid ||
          this.$v.searchLocation.$invalid
        ) {
          return;
        }
      }
      if (this.selectItem == "seminarItem") {
        this.$v.selectDataList.$each.$touch();
        if (this.$v.selectDataList.$each.$invalid) {
          return;
        }
        // this.form.Coupon = "";
        this.form.StoreIds = [];
        delete this.form.ShippingDetailDTO;
        delete this.form.StoreGuestUser;
        this.form.Price = 0;
        this.selectDataList.forEach((item) => {
          this.form.SeminarIds.push(item.selectedItem);
        });
        this.form.PaidAmount = this.totalSeminarPrice;
      }
      if (this.PaymentOption == "offline") {
        this.submitBtnloader = true;
        if (this.selectItem == "storeItem") {
          if (this.storeItemArray[0].id == null) {
            return;
          }
        }
        // delete this.form.BillingDetails;
        delete this.form.Payment;
        if (this.membershipNewsTogglebtn) {
          this.$v.form.ShippingDetailDTO.$touch();

          if (this.$v.form.ShippingDetailDTO.$invalid) {
            return;
          }
        }
        this.form.Price = this.totalPrice - this.discounted - this.couponDiscount + this.shippingPrice + this.taxVal;
          // this.submitBtnloader = true;
          if (this.selectItem == "storeItem") {
            await this.addItemsToCart();
          }
          await this.$store.dispatch("ProcessOfflinePaymentBySeminarOrStore", this.form).then(() => {
            this.submitBtnloader = false;
              this.$swal.fire({
                position: "top-end",
                icon: "success",
                title: "Order Placed Successfully",
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });
              }).catch(()=>{
                this.$swal.fire({
                position: "top-end",
                icon: "error",
                title: "Something went wrong",
                showConfirmButton: false,
                timer: 3000,
                toast: true,
              });
            })
          this.close();
        return;
      }
      // this.$v.form.BillingDetails.$touch();
      this.$v.form.Payment.$touch();
      // if (this.$v.form.BillingDetails.$invalid) {
      //   return;
      // }
      if (this.$v.form.Payment.$invalid) {
        return;
      }
      if (this.selectItem == "storeItem") {
        // await this.storeItemArray.forEach((item) => {
        //   const obj = {
        //     UserId: this.GetPreviewUser.Id,
        //     IsUser: true,
        //     ProductId: item.id,
        //     GuestId: "",
        //     Quantity: item.quantity,
        //   };
        //   this.$store.dispatch("AddToCart", obj);
        // });
        this.form.Price =
          this.totalPrice - this.discounted - this.couponDiscount;
      }
      this.submitBtnloader = true;
      if (this.selectItem == "storeItem") {
        await this.addItemsToCart();
      }
      await this.$store.dispatch("UserPayment", this.form).then(() => {
        this.submitBtnloader = false;
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Order Placed Successfully",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      }).catch(()=>{
        this.submitBtnloader = false;
        this.$swal.fire({
          position: "top-end",
          icon: "error",
          title: "Something went wrong",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      })
      const userId = this.GetPreviewUser.Id;
      this.$store.dispatch("GetUserPurchaseAndBillings", { id: userId });
      this.close();
    },
    GoToStepTwo() {
      if (this.selectItem == "storeItem") {
        this.$v.storeItemArray.$each.$touch();
        if (this.$v.storeItemArray.$each.$invalid) {
          return;
        }
      }
      if (this.selectItem == "seminarItem") {
        this.$v.selectDataList.$each.$touch();
        if (this.$v.selectDataList.$each.$invalid) {
          return;
        }
      }
      if (this.membershipNewsTogglebtn) {
        this.$v.form.ShippingDetailDTO.$touch();
        if (this.$v.form.ShippingDetailDTO.$invalid) {
          return;
        }
      }
      this.stepOne = false;
      this.stepTwo = true;
    },
    GoBack() {
      this.stepTwo = false;
      this.stepOne = true;
    },
    showSubcribeModel() {
      if (this.membershipNewsTogglebtn == true) {
        this.membershipNewsToggleOne = true;
      } else {
        this.membershipNewsToggleOne = false;
      }
    },
  },
};
</script>

<style scoped>
.heading-3 {
  font-size: 18px;
  font-weight: 500;
}
.h1 {
  font-size: 26px;
  font-weight: 700;
}
.h2 {
  font-size: 22px;
  font-weight: 700;
}
.font-20{
  font-size: 20px;
}
.font-18 {
  font-size: 18px;
}
.font-16-green {
  font-size: 16px;
  color: #06a13b;
}
table,
td,
th {
  border: 1px solid;
}
th {
  background-color: #cccccc;
}
.divider {
  border-color: #e6e6e6;
}
.gmap-autocomplete {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  outline: none;
  border-radius: 0;
  background: transparent;
  height: 40px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.gmap-autocomplete:focus {
  border-bottom: 2px solid #1976d2;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-top: 2px;
  margin-bottom: 4px;
}
</style>
